import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Searcher from "../../../searcher/index.js";
import { SearcherItem } from "../../../searcher/styled.js";
import SearcherFlightHotelAccommodationInput from "../../components/accommodation-input/index.js";
import SearcherFlightHotelButton from "../../components/button/index.js";
import SearcherFlightHotelClassesInput from "../../components/classes-input/index.js";
import SearcherFlightHotelDatesInput from "../../components/dates-input/index.js";
import SearcherFlightHotelDiscountsInput from "../../components/discounts-input/index.js";
import SearcherFlightHotelLocationInput from "../../components/location-input/index.js";
import SearcherFlightHotelForm from "../../components/searcher-form/index.js";
import useSearcherFlightHotelView from "../../hooks/useSearcherFlightHotelView.js";
const SearcherFlightHotelMobileView = ()=>{
    const { mustShowDiscounts , mustShowClasses  } = useSearcherFlightHotelView();
    return /*#__PURE__*/ _jsxs(Searcher, {
        "data-testid": "SearcherFlightHotel",
        children: [
            /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelLocationInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelDatesInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelAccommodationInput, {})
            }),
            mustShowClasses && /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelClassesInput, {})
            }),
            mustShowDiscounts && /*#__PURE__*/ _jsx(SearcherItem, {
                children: /*#__PURE__*/ _jsx(SearcherFlightHotelDiscountsInput, {})
            }),
            /*#__PURE__*/ _jsx(SearcherFlightHotelButton, {})
        ]
    });
};
const SearcherFlightHotelMobile = (props)=>/*#__PURE__*/ _jsx(SearcherFlightHotelForm, {
        ...props,
        children: /*#__PURE__*/ _jsx(SearcherFlightHotelMobileView, {})
    });
export default SearcherFlightHotelMobile;

//# sourceMappingURL=index.js.map